/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserUpdateOrganization
 */
export interface OrgUserUpdateOrganization {
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    new_org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    join_org_pin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    group_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserUpdateOrganization
     */
    skip_approval_check: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    role?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    old_organization_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    org_user_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    user_history_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateOrganization
     */
    user_private_settings_azure_id: string;
}

/**
 * Check if a given object implements the OrgUserUpdateOrganization interface.
 */
export function instanceOfOrgUserUpdateOrganization(value: object): value is OrgUserUpdateOrganization {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('new_org_code' in value) || value['new_org_code'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    if (!('skip_approval_check' in value) || value['skip_approval_check'] === undefined) return false;
    if (!('old_organization_azure_id' in value) || value['old_organization_azure_id'] === undefined) return false;
    if (!('org_user_azure_id' in value) || value['org_user_azure_id'] === undefined) return false;
    if (!('user_history_azure_id' in value) || value['user_history_azure_id'] === undefined) return false;
    if (!('user_private_settings_azure_id' in value) || value['user_private_settings_azure_id'] === undefined) return false;
    return true;
}

export function OrgUserUpdateOrganizationFromJSON(json: any): OrgUserUpdateOrganization {
    return OrgUserUpdateOrganizationFromJSONTyped(json, false);
}

export function OrgUserUpdateOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserUpdateOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'new_org_code': json['new_org_code'],
        'join_org_pin': json['join_org_pin'] == null ? undefined : json['join_org_pin'],
        'group_name': json['group_name'],
        'skip_approval_check': json['skip_approval_check'],
        'role': json['role'] == null ? undefined : json['role'],
        'old_organization_azure_id': json['old_organization_azure_id'],
        'org_user_azure_id': json['org_user_azure_id'],
        'user_history_azure_id': json['user_history_azure_id'],
        'user_private_settings_azure_id': json['user_private_settings_azure_id'],
    };
}

export function OrgUserUpdateOrganizationToJSON(json: any): OrgUserUpdateOrganization {
    return OrgUserUpdateOrganizationToJSONTyped(json, false);
}

export function OrgUserUpdateOrganizationToJSONTyped(value?: OrgUserUpdateOrganization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'new_org_code': value['new_org_code'],
        'join_org_pin': value['join_org_pin'],
        'group_name': value['group_name'],
        'skip_approval_check': value['skip_approval_check'],
        'role': value['role'],
        'old_organization_azure_id': value['old_organization_azure_id'],
        'org_user_azure_id': value['org_user_azure_id'],
        'user_history_azure_id': value['user_history_azure_id'],
        'user_private_settings_azure_id': value['user_private_settings_azure_id'],
    };
}

